import { Button, Group, Text } from "@mantine/core";

type Props = {
  readonly pageSize: number;
  readonly itemCount: number;
  readonly hasMore: boolean;
  readonly canGoPrev: boolean;
  readonly onPrev: () => void;
  readonly onNext: () => void;
  readonly loading?: boolean;
};

/** 大表 keyset 分页：仅上一页 / 下一页，不依赖精确总数。 */
export function CursorPagination(props: Props) {
  const { pageSize, itemCount, hasMore, canGoPrev, onPrev, onNext, loading = false } = props;

  if (itemCount === 0 && !canGoPrev) {
    return (
      <Text size="sm" c="dimmed" ta="center" py="sm">
        共 0 条记录
      </Text>
    );
  }

  return (
    <Group justify="space-between" align="center" mt="sm" wrap="wrap" gap="sm">
      <Text size="sm" c="dimmed">
        本页 {itemCount} 条（每页最多 {pageSize} 条）
        {hasMore ? "，还有更多" : canGoPrev || itemCount > 0 ? "，已到末页" : ""}
      </Text>
      <Group gap="xs">
        <Button size="xs" variant="default" disabled={!canGoPrev || loading} onClick={onPrev}>
          上一页
        </Button>
        <Button size="xs" variant="default" disabled={!hasMore || loading} onClick={onNext}>
          下一页
        </Button>
      </Group>
    </Group>
  );
}
